export default __webpack_public_path__ + "static/media/chain-8.cf4001bc.png";